import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import Button from "../../../components/Button/Button";
import { API_URL, appFetch } from "../../../helpers/fetch";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useAppDispatch } from "../../../hooks";
import { set } from "lodash";
type DetailsStepType = {
  handleNextStep: () => void;
  setFormValues: React.Dispatch<React.SetStateAction<undefined>>;
  formValues: any;
};

const DetailsStep = ({
  handleNextStep,
  setFormValues,
  formValues,
}: DetailsStepType) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    defaultValues: {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      businessName: formValues?.businessName,
      referralCode: formValues?.referralCode,
      emailAddress: formValues?.emailAddress,
      mobilePhone: formValues?.mobilePhone,
      branchName: formValues?.branchName,
      wholesale: formValues?.wholesale,
    },
  });
  const dispatch = useAppDispatch();

  const onSubmit = (data: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      ...data,
    }));
    handleNextStep();
  };
  const onError = (errros: any) => {
    // console.log(errros, "err");
  };

  const selectInputRef = useRef<any>(null);

  const onClear = () => {
    if (selectInputRef.current) {
      selectInputRef.current.clearValue();
    } else {
      console.error("selectInputRef is null");
    }
  };

  const [showBranchSelect, setShowBranchSelect] = useState(false);
  const [branchsList, setBranchsList] = useState([{ value: "", label: "" }]);
  const [wholesalerList, setWholesalerList] = useState([
    { value: "", label: "" },
  ]);

  useEffect(() => {
    fetchOptions();
  }, []);

  interface ApiData {
    uuid: string;
    ident: string;
  }

  interface TransformedData {
    value: string;
    label: string;
  }

  function transformData(data: ApiData[]): TransformedData[] {
    return data.map((item) => ({
      value: item.uuid,
      label: item.ident,
    }));
  }

  const fetchOptions = () => {
    setTimeout(() => {
      fetch(API_URL + "/wholesaler/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then(
          (result) => {
            if (result.status.success) {
              setWholesalerList(transformData(result.data));
            } else {
              console.warn("List of wholesalers not found");
            }
          },
          (error) => {
            console.warn("List of wholesalers not found");
          }
        );
    }, 100);
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setTimeout(() => {
      fetch(API_URL + "/wholesaler/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then(
          (result) => {
            if (result.status.success) {
              callback(transformData(result.data));
            } else {
              console.warn("List of wholesalers not found");
            }
          },
          (error) => {
            console.warn("List of wholesalers not found");
          }
        );
    }, 1000);
  };

  const loadOptionsBranchStatic = (uuid: any) => {
    fetch(API_URL + "/wholesaler/branch/list ", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ wholesaler: { uuid: uuid } }),
    })
      .then((response) => {
        return response.json();
      })
      .then(
        (result) => {
          if (result.status.success) {
            const transformedData = result.data.map((item: any) => ({
              value: item.uuid,
              label: item.ident,
            }));
            setShowBranchSelect(true);
            setBranchsList(transformedData);
          } else {
            console.warn("List of wholesalers not found");
          }
        },
        (error) => {
          console.warn("List of wholesalers not found");
        }
      );
  };

  return (
    <div className="form-step">
      <form
        className="form"
        noValidate
        autoComplete="off"
        method="POST"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="input-item">
          <label htmlFor="firstName">Imię</label>
          <input
            placeholder="Twoje imię"
            className={errors.firstName && "error-input"}
            type="text"
            id="firstName"
            {...register("firstName", {
              required: true,
              pattern: /^[\sa-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ-]*$/,
            })}
          ></input>
          {errors.firstName && errors?.firstName?.type === "pattern" && (
            <p className="error">Nieprawidłowa wartość</p>
          )}
          {errors.firstName && errors?.firstName?.type === "required" && (
            <p className="error">Wpisz imię</p>
          )}
        </div>
        <div className="input-item">
          <label htmlFor="lastName">Nazwisko</label>
          <input
            placeholder="Kowalski"
            className={errors.lastName && "error-input"}
            type="text"
            id="lastName"
            {...register("lastName", {
              required: true,
              pattern: /^[\sa-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ-]*$/,
            })}
          ></input>
          {errors.lastName && errors?.lastName?.type === "pattern" && (
            <p className="error">Nieprawidłowa wartość</p>
          )}
          {errors.lastName && errors?.lastName?.type === "required" && (
            <p className="error">Wpisz nazwisko</p>
          )}
        </div>
        <div className="input-item">
          <label htmlFor="emailAddress">E-mail</label>
          <input
            placeholder="Twój adres e-mail"
            className={errors.emailAddress && "error-input"}
            type="text"
            id="emailAddress"
            {...register("emailAddress", {
              required: true,
              pattern:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            })}
          ></input>
          {errors.emailAddress && errors?.emailAddress?.type === "pattern" && (
            <p className="error">Nieprawidłowy adres e-mail</p>
          )}
          {errors.emailAddress && errors?.emailAddress?.type === "required" && (
            <p className="error">Wpisz adres e-mail</p>
          )}
        </div>
        <div className="input-item">
          <label htmlFor="mobilePhone">
            Telefon <br />
            <span>
              Numer telefonu potrzebny jest, aby w pełni korzystać z programu.
            </span>
          </label>
          <div className="prefix-input-wrapper">
            <span className="prefix">+48</span>
            <input
              placeholder="601602603"
              className={errors.mobilePhone && "error-input"}
              type="text"
              id="mobilePhone"
              {...register("mobilePhone", {
                required: true,
                pattern: /^\d{9}$/,
              })}
            ></input>
          </div>
          {errors.mobilePhone && errors?.mobilePhone?.type === "pattern" && (
            <p className="error">Nieprawidłowy numer telefonu</p>
          )}
          {errors.mobilePhone && errors?.mobilePhone?.type === "required" && (
            <p className="error">Wpisz numer telefonu</p>
          )}
        </div>

        <div className="input-item">
          <label htmlFor="wholesale">Nazwa hurtowni</label>
          <Controller
            name="wholesale"
            control={control}
            rules={{ required: "Nazwa hurtowni is required" }}
            render={({ field }) => (
              <Select
                {...field}
                // cacheOptions
                // defaultOptions
                // loadOptions={loadOptions},
                options={wholesalerList}
                placeholder="Podaj nazwę hurtowni"
                noOptionsMessage={() => "Brak hurtowni o podanej nazwie"}
                className={
                  errors.wholesale ? "error-input businessName" : "businessName"
                }
                onChange={(event: any) => {
                  field.onChange(event);
                  loadOptionsBranchStatic(event.value);
                }}
                onFocus={() => onClear()}
              />
            )}
          />
          {errors.wholesale && <p className="error">Pole wymagane</p>}
        </div>

        {showBranchSelect && (
          <div className="input-item">
            <label htmlFor="branchName">Nazwa oddziału</label>
            <Controller
              name="branchName"
              control={control}
              rules={{ required: "Nazwa oddziału jest wymagana" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={branchsList}
                  ref={selectInputRef}
                  className={
                    errors.branchName
                      ? "error-input businessName"
                      : "businessName"
                  }
                  placeholder="Podaj nazwę oddziału"
                  noOptionsMessage={() => "Brak oddziału o podanej nazwie"}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption);
                  }}
                />
              )}
            />
            {errors?.branchName && <p className="error">Pole wymagane</p>}
          </div>
        )}

        <div className="input-item">
          <label htmlFor="referralCode">Kod polecający</label>
          <input
            placeholder="66594"
            className={errors.referralCode && "error-input"}
            type="text"
            id="referralCode"
            {...register("referralCode", { required: true, pattern: /^.{6}$/ })}
          ></input>
          {errors.referralCode && errors?.referralCode?.type === "pattern" && (
            <p className="error">Nieprawidłowy kod polecający</p>
          )}
          {errors.referralCode && errors?.referralCode?.type === "required" && (
            <p className="error">Wpisz kod polecający</p>
          )}
        </div>
        <Button type="submit" onClick={handleSubmit(onSubmit, onError)}>
          Dalej
        </Button>
        <div className="text-center margin-20">
          <Link to="/login">Powrót do logowania</Link>
        </div>
      </form>
    </div>
  );
};
export default DetailsStep;
